import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cuánto tiempo toma una remodelación?',
  answer: 'El tiempo varía según la magnitud del proyecto. Una remodelación estándar puede tomar entre 2 a 4 semanas desde que iniciamos los trabajos. Siempre proporcionamos un cronograma detallado antes de comenzar.'
}, {
  question: '¿Qué incluye la inspección gratuita?',
  answer: 'Nuestra inspección gratuita incluye una evaluación completa del estado actual de su piscina, equipos (bombas, filtros), detección visual de posibles problemas estructurales y una consulta para entender sus objetivos de remodelación.'
}, {
  question: '¿Ofrecen financiamiento?',
  answer: 'Sí, trabajamos con varios socios financieros para ofrecer opciones de pago flexibles que se adapten a su presupuesto. Pregunte a nuestro asesor durante su inspección.'
}, {
  question: '¿Qué áreas cubren en Central Florida?',
  answer: 'Servimos a toda el área de Central Florida, incluyendo Orlando, Kissimmee, Davenport, Winter Garden, Clermont, Windermere y comunidades circundantes.'
}, {
  question: '¿El mantenimiento gratis incluye químicos?',
  answer: 'Sí, nuestra oferta especial de 2-3 meses de mantenimiento gratis incluye el balanceo químico básico y la limpieza rutinaria para asegurar que su nueva piscina se mantenga en perfectas condiciones.'
}, {
  question: '¿Están asegurados y certificados?',
  answer: 'Absolutamente. Somos una empresa Fully Insured y nuestro personal cuenta con certificación CPO (Certified Pool & Spa Operator), garantizando los más altos estándares de seguridad y calidad.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-gray-50" data-id="element-110">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-111">
        <div className="text-center mb-12" data-id="element-112">
          <h2 className="text-pool-600 font-semibold tracking-wider uppercase text-sm mb-2" data-id="element-113">
            Preguntas Frecuentes
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-navy-900" data-id="element-114">
            Resolvemos sus Dudas
          </h3>
        </div>

        <div className="space-y-4" data-id="element-115">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-116">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-117">
                <span className="font-bold text-navy-900 text-lg pr-8" data-id="element-118">
                  {faq.question}
                </span>
                <ChevronDown className={`text-pool-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-119" />
              </button>
              <AnimatePresence data-id="element-120">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-121">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-122">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}